import { createReducer } from "@reduxjs/toolkit";
import { PsychologicalAssessmentActionsNames } from "../constants/actionTypes";
import { IPsychologicalAssessment } from "../interfaces/store/IPsychologicalAssessment";
import { PsychologicalAssessmentActions } from "../actions/psychologicalAssessmentActions";

const init = (): IPsychologicalAssessment => {
    return {
        evaluationForm: {}
    } as IPsychologicalAssessment
}

export const psychologicalAssessmentReducer = createReducer(init(), (builder) => {
    builder.addCase(PsychologicalAssessmentActions.updateEvaluationForm, (state, action) => {
        state.evaluationForm = action.payload
    }).addCase(PsychologicalAssessmentActions.updateInitialEvalutationForm, (state, action) => {
        state.initialEvaluationForm = action.payload
    })
})